export default __webpack_public_path__ + "static/media/dark.688acde2.svg";